import { usePostPortfolioPensionProductsMutation } from "web_myplann/Api/Portfolio/Mutations/usePostPortfolioPensionProductsMutation";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { PENSION_FORM_DEFAULT_VALUES } from "web_myplann/Portfolio/Forms/PensionForm/pensionFormDefaults";
import { getPensionFormSchema } from "web_myplann/Portfolio/Forms/PensionForm/pensionFormSchema";
import { useCreatePortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useCreatePortfolioForm";

export const useCreatePensionForm = () => {
	const { t } = useResource();
	const { mutate, isPending } = usePostPortfolioPensionProductsMutation();

	const { form, onSubmit } = useCreatePortfolioForm({
		schema: getPensionFormSchema(t),
		defaultValues: PENSION_FORM_DEFAULT_VALUES,
		mutate,
		successRoute: Routing.Portfolio.PortfolioAddPensionSuccess.path(),
	});

	return { form, onSubmit, isPending };
};
